import { render, staticRenderFns } from "./formCreateBase.vue?vue&type=template&id=deaed112"
import script from "./formCreateBase.vue?vue&type=script&lang=js"
export * from "./formCreateBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deaed112')) {
      api.createRecord('deaed112', component.options)
    } else {
      api.reload('deaed112', component.options)
    }
    module.hot.accept("./formCreateBase.vue?vue&type=template&id=deaed112", function () {
      api.rerender('deaed112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/base/components/form/formCreateBase.vue"
export default component.exports